export default __webpack_public_path__ + "static/flyer3@2x-b636c64d55aeefd2584e5c7cf4249f5d.jpg";